var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "Modal2",
        {
          attrs: {
            title: "WhatsApp V3 Başlangıç Mesajı",
            description:
              "Sohbet başlatmak için bir başlangıç mesajı girmeniz gerekmektedir",
            "cancel-text": "Vazgeç",
            "ok-text": "Sohbet Başlat",
            design: "v2",
            "class-name": "initial-message-modal",
            "show-footer": false,
          },
          on: { cancel: _vm.cancel, ok: _vm.confirm },
        },
        [
          _c("div", { staticClass: "initial-message-content" }, [
            _c("div", { staticClass: "whatsapp-info-card" }, [
              _c("div", { staticClass: "card-icon" }, [
                _c("div", { staticClass: "whatsapp-icon" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "32",
                        height: "32",
                        viewBox: "0 0 24 24",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.893 3.346",
                          fill: "#25D366",
                        },
                      }),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-content" }, [
                _c("h4", [_vm._v("WhatsApp V3 Kanalı")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                    Bu kanal türü için sohbet başlatırken bir başlangıç mesajı gereklidir. Bu mesaj, karşı tarafa\n                    gönderilen ilk mesaj olacaktır.  Eğer boş bırakırsanız karşı tarafa bir adet boşluk içeren boş  mesaj iletilecektir.\n                "
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "message-input-section" }, [
              _c("div", { staticClass: "input-header" }, [
                _c("label", [_vm._v("Başlangıç Mesajı")]),
                _vm._v(" "),
                _c("span", { staticClass: "required-badge" }, [
                  _vm._v("Önemli"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "message-input-wrapper" },
                [
                  _c("a-textarea", {
                    ref: "messageInput",
                    staticClass: "message-textarea",
                    attrs: {
                      placeholder: "Merhaba! Size nasıl yardımcı olabilirim?",
                      rows: 4,
                      maxlength: 500,
                      "show-count": "",
                    },
                    model: {
                      value: _vm.initialMessage,
                      callback: function ($$v) {
                        _vm.initialMessage = $$v
                      },
                      expression: "initialMessage",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.initialMessage.trim()
              ? _c("div", { staticClass: "preview-section" }, [
                  _c("h5", [_vm._v("Önizleme")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "message-preview" }, [
                    _c("div", { staticClass: "preview-bubble" }, [
                      _c("div", { staticClass: "bubble-content" }, [
                        _vm._v(_vm._s(_vm.initialMessage.trim())),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "bubble-time" }, [
                        _vm._v("Şimdi"),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-actions" },
            [
              _c(
                "a-button",
                { staticClass: "cancel-btn", on: { click: _vm.cancel } },
                [_vm._v(" Vazgeç ")]
              ),
              _vm._v(" "),
              _vm.isValid
                ? _c(
                    "a-button",
                    {
                      staticClass: "confirm-btn",
                      attrs: { type: "primary", loading: _vm.isProcessing },
                      on: { click: _vm.confirm },
                    },
                    [
                      !_vm.isProcessing
                        ? _c("span", [_vm._v("Sohbet Başlat")])
                        : _c("span", [_vm._v("Başlatılıyor...")]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isValid
                ? _c(
                    "a-button",
                    {
                      staticClass: "confirm-btn empty-message-btn",
                      attrs: { type: "primary", loading: _vm.isProcessing },
                      on: { click: _vm.confirmWithEmptyMessage },
                    },
                    [
                      !_vm.isProcessing
                        ? _c("span", [_vm._v("Sohbet Başlat (Boş Mesaj ile)")])
                        : _c("span", [_vm._v("Başlatılıyor...")]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }